<section class="hero-carousel">
  <div class="slides-container">
    <app-home-hero-slide
      *ngFor="let slide of slides; let i = index"
      [slide]="slide"
      [isActive]="i === activeIndex()"
    >
    </app-home-hero-slide>
  </div>

  <div class="controls-wrapper container">
    <app-carousel-controls (prev)="prev()" (next)="next()"> </app-carousel-controls>
  </div>

  <div class="indicators">
    <button
      *ngFor="let slide of slides; let i = index"
      class="indicator"
      [class.active]="i === activeIndex()"
      (click)="activeIndex.set(i); stopAutoPlay(); startAutoPlay()"
      aria-label="Go to slide"
    ></button>
  </div>
</section>
